export function isLocalMedia(url) {
  return typeof url === "string" && url.startsWith("/api/media/");
}

export function mediaSrc(url) {
  const token = localStorage.getItem("wb_token");
  return token ? `${url}?auth=${encodeURIComponent(token)}` : url;
}

export function toEmbedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace("www.", "");
    if (host === "youtu.be") return `https://www.youtube.com/embed${u.pathname}`;
    if (host.endsWith("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}`;
      const parts = u.pathname.split("/").filter(Boolean);
      if (parts[0] === "shorts" && parts[1]) return `https://www.youtube.com/embed/${parts[1]}`;
      if (parts[0] === "embed" && parts[1]) return url;
    }
    if (host.endsWith("vimeo.com")) {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id) return `https://player.vimeo.com/video/${id}`;
    }
    if (host.endsWith("loom.com")) {
      const parts = u.pathname.split("/").filter(Boolean);
      const id = parts[0] === "share" ? parts[1] : parts[0] === "embed" ? parts[1] : null;
      if (id) return `https://www.loom.com/embed/${id}`;
    }
    return url;
  } catch {
    return null;
  }
}
